// @flow
import React from 'react';
import cx from 'classnames';

import './FakeEventCard.scss';
import Eventpone from '../Eventpone/Eventpone';

type Props = {
  oneColumn?: boolean,
};

const FakeEventCard = ({ oneColumn }: Props) => (
  <Eventpone duration={100}>
    <div className={cx('EventCard FakeEventCard', { 'one-column': oneColumn })}>
      <div className="thumbnail-wrapper">
        <img
          src="https://images.cacheby.com/placeholder.png?s=600x316&t=crop&q=82&f=webp"
          alt="thumbnail"
        />
      </div>
    </div>
  </Eventpone>
);

FakeEventCard.defaultProps = {
  oneColumn: false,
};

export default FakeEventCard;



// WEBPACK FOOTER //
// ./src/components/common/FakeEventCard/FakeEventCard.js